import FileUpload from '@/components/upload-file'
import { Datetime } from 'vue-datetime'
import 'vue-datetime/dist/vue-datetime.css'

export default {
  name: 'create',
  components: {FileUpload, Datetime},
  props: [],
  data () {
    return {
      normalizer (node) {
        return {
          id: node.id,
          label: node.name,
          children: node.children
        }
      },
      document: {
        name: '',
        version: '',
        exp_date: '',
        document_id: '',
        doc_id: ''
      },
      errors: {},
      accept: '.xlsx,.xls,.doc, .docx,.ppt, .pptx,.txt,.pdf',
      btn_reset: false,
      btn_create: false,
      loading: true,
    }
  },
  computed: {
    documents () {
      return this.$store.getters['Document/getListDocument']
    }
  },
  mounted () {
  },
  methods: {
    create () {
      const fd = new FormData()
      fd.append('file_path', this.document.file==undefined ? '':this.document.file)
      fd.append('name', this.document.name)
      fd.append('version', this.document.version)
      fd.append('grp_doc_id', this.document.grp_doc_id)
      fd.append('exp_date', this.document.exp_date== ''?'':this.$moment(this.document.exp_date).format('YYYY-MM-DD'))
      fd.append('doc_id', this.document.doc_id)
    
      this.btn_reset = true
      this.btn_create = true
      this.$store.dispatch('Document/createDocument', {document: fd}).then(res => {
        
        this.file = ''
        this.btn_reset = false
        this.btn_create = false
        this.errors = []
        this.$notify({
          group: 'success',
          title: this.$t('notify.notify'),
          text: this.$t('notify.create_success')
        })
        this.$refs.createModal.hide()
      }).catch(errors => {
        if (errors.status === 422) {
          this.errors = errors.data.error
        }
        this.btn_reset = false
        this.btn_create = false
        
      })
    },
    show (group) {
      console.log(group)
      this.$refs.file.reset()
      this.document = {
        name: '',
        version: '',
        grp_doc_id: group.id,
        exp_date: '',
        document_id: '',
        doc_id: '',
        file_path: '',
        file: ''
      }
      this.$refs.createModal.show()
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/document/create/create.js